import { AllSanitySchemaTypes, internalGroqTypeReferenceTo } from "@/lib/types";

// Single reference resolver
export function resolveReference<T>(obj: {
  _type: "reference";
  [internalGroqTypeReferenceTo]?: T;
}) {
  if (obj._type === "reference") throw new Error("Asset reference has not been expanded!");
  return obj as unknown as Extract<AllSanitySchemaTypes, { _type: T }>;
}

// Array reference resolver
export function resolveReferences<T>(
  arr: Array<{
    _type: "reference";
    [internalGroqTypeReferenceTo]?: T;
  }>,
): Array<Extract<AllSanitySchemaTypes, { _type: T }>> {
  return arr.map((obj) => {
    if (obj._type === "reference") throw new Error("Asset reference has not been expanded!");
    return obj as unknown as Extract<AllSanitySchemaTypes, { _type: T }>;
  });
}
